import { render, staticRenderFns } from "./pub_placard.vue?vue&type=template&id=153620c9&scoped=true"
import script from "./pub_placard.vue?vue&type=script&lang=js"
export * from "./pub_placard.vue?vue&type=script&lang=js"
import style0 from "./pub_placard.vue?vue&type=style&index=0&id=153620c9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "153620c9",
  null
  
)

export default component.exports